import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getAccounts} = api.accounts;

const getAccountsRefresh = atom<number>({
  key: 'getAccountsRefresh',
  default: 0,
});

const getAccountsQuery = selectorFamily({
  key: 'getAccounts',
  get(params: Parameters<typeof getAccounts>[0]) {
    return async ({get}) => {
      get(getAccountsRefresh);

      try {
        const {data} = await getAccounts(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetAccountsQuery = createQuery(getAccountsQuery, getAccountsRefresh);
